<template>
  <div class="contact-info" :class="[`is-${stock.ics_type}`]">
    <div class="contact-info-content">
      <ref-info :stock="stock" />
      <transition name="fade" mode="out-in">
        <div 
          v-for="(agent, index) in stock.agents"
          v-if="currentDisplayEmployeeIndex === index" 
          class="info-row"
          key="emp1" 
        >
          
          <span v-if="$i18n.locale === 'en'">
            {{ agent.emp_eng_name }}
          </span>
          <span v-else>
            {{ agent.emp_chi_name }} {{ agent.emp_nickname }}
          </span>
          <span class="tele"><i class="fa fa-phone fa-flip-horizontal" /> {{ agent.emp_tele }}</span>
          
        </div>
      </transition>
      </div>
  </div>
</template>

<script>
import RefInfo from '@/components/Stock/RefInfo';

export default {
  props: ['stock'],
  components: {
    RefInfo,
  },
  data() {
    return {
      currentDisplayEmployeeIndex: 0,
    };
  },
};
</script>

<style scoped>
.contact-info {
  width: 100%;
  padding: 10px 5px;
  font-size: 1.2rem;
}

.contact-info > *, .contact-info > * > * {
  color: #fff !important;
}

.contact-info {
  font-size: 1.2rem;
}

.is-c.contact-info {
  background-color: #008CBA;
}

.is-i.contact-info {
  background-color: #47337C;
}

.is-s.contact-info {
  background-color: #DA4E00;
}

.contact-info-content {
  display: flex;
  justify-content: space-between;  
  align-items: flex-end;
  padding-right: 5px;
}

.info-row {
  line-height: 1.2rem;
}

.contact-info-content > .info-row > .tele {
  margin-left: 10px;
}


</style>